import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ViventiaLogo } from '@/routes/_app/-components/orgs/assets/client-viventia'
import { LanguageSelector } from '@/routes/_app/-components/language-selector'
import { GroupSurveyPending } from '@/routes/_app/-components/orgs/group-login-pending'

export const Route = createFileRoute('/_public/orgs/$orgId/users/groups')({
  component: RouteComponent,
  pendingComponent: GroupSurveyPending,
})

function RouteComponent() {
  return (
    <div className="flex flex-col items-center gap-10">
      <ViventiaLogo className="mx-auto h-28 w-full" />
      <Outlet />

      <div className="fixed top-0 right-0 m-6">
        <LanguageSelector />
      </div>
    </div>
  )
}
